exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".confirm-modal-class .ivu-modal{position:relative;max-width:90%}", ""]);

// exports
